const config = {
  webSocketUrl: (window as any).env.REACT_APP_WEB_SOCKET_URL,
  httpsUrl: (window as any).env.REACT_APP_HTTPS_URL,
};

export default config;
